import { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import api from "../../../../api/api";
import "../../../../components/table.css";
import VisibilityIcon from "@mui/icons-material/Visibility";
import DownloadIcon from "@mui/icons-material/Download";
import EditIcon from "@mui/icons-material/Edit";
import Pagination from "../../../../components/Pagination";
import BackButton from "../../../../components/BackButton";
import Table from "../../../../components/table";
import usePagination from "../../../../utils/usePagination";
import Tooltip from "@mui/material/Tooltip";
import JSZip from "jszip";
 
const ListofBLAdmin = () => {
  const [enquiries, setEnquiries] = useState([]);
  const [loading, setLoading] = useState(true);
 
  const {
    currentPage,
    itemsPerPage,
    totalPages,
    totalItems,
    currentItems,
    goToPage,
    handleItemsPerPageChange,
  } = usePagination(enquiries, 5);
 
  const handleDownload = async (enqId, documentName, fileName) => {
    try {
      const response = await api.get(
        `/download-document/bl/${enqId}?documentName=${encodeURIComponent(documentName)}`,
        { responseType: "blob" },
      );
      const blob = response.data;
      const url = window.URL.createObjectURL(blob);
      const link = document.createElement("a");
      link.href = url;
      link.download = fileName || "BL_Draft.pdf";
      document.body.appendChild(link);
      link.click();
      document.body.removeChild(link);
      window.URL.revokeObjectURL(url);
    } catch (error) {
      console.error("Download failed:", error);
    }
  };

  // Download Non-Negotiable - single file or ZIP for Switch BL
  const handleDownloadNonNegotiable = async (enqId, isSwitchBL) => {
    try {
      if (isSwitchBL) {
        // Download both Non-Negotiable BL1 and BL2 as ZIP
        const [response1, response2] = await Promise.all([
          api.get(`/download-document/bl/${enqId}?documentName=${encodeURIComponent("Non Negotiable - BL1")}`, { responseType: "blob" }),
          api.get(`/download-document/bl/${enqId}?documentName=${encodeURIComponent("Non Negotiable - BL2")}`, { responseType: "blob" })
        ]);

        const zip = new JSZip();
        zip.file(`Non_Negotiable_BL1_${enqId}.pdf`, response1.data);
        zip.file(`Non_Negotiable_BL2_${enqId}.pdf`, response2.data);

        const zipBlob = await zip.generateAsync({ type: "blob" });
        const url = window.URL.createObjectURL(zipBlob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Non_Negotiable_SwitchBL_${enqId}.zip`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      } else {
        // Download single Non-Negotiable
        const response = await api.get(
          `/download-document/bl/${enqId}?documentName=${encodeURIComponent("Non Negotiable")}`,
          { responseType: "blob" },
        );
        const blob = response.data;
        const url = window.URL.createObjectURL(blob);
        const link = document.createElement("a");
        link.href = url;
        link.download = `Non_Negotiable_${enqId}.pdf`;
        document.body.appendChild(link);
        link.click();
        document.body.removeChild(link);
        window.URL.revokeObjectURL(url);
      }
    } catch (error) {
      console.error("Download Non-Negotiable failed:", error);
    }
  };
 
  useEffect(() => {
    const fetchEnquiries = async () => {
      try {
        const response = await api.get("/bl/bl-list-admin");
        setEnquiries(
          Array.isArray(response.data.bookings) ? response.data.bookings : [],
        );
      } catch (error) {
        console.error("Failed to fetch bookings:", error);
        setEnquiries([]);
      } finally {
        setLoading(false);
      }
    };
 
    fetchEnquiries();
  }, []);
 
  const columns = [
    { label: "Bookings No", accessor: "enq_id" },
    {
      label: "Company Name",
      accessor: "client_company",
      render: (data) => {
        const companyName = data.client_company || "-";
 
        return (
          <Tooltip title={companyName} arrow placement="top">
            <div
              style={{
                maxWidth: "150px",
                whiteSpace: "nowrap",
                overflow: "hidden",
                textOverflow: "ellipsis",
                cursor: "pointer",
              }}
            >
              {companyName}
            </div>
          </Tooltip>
        );
      },
    },
    { label: "POL", accessor: "pol" },
    { label: "POD", accessor: "pod" },
    { label: "Status", accessor: "Status" },
 
    {
      label: "Express BL Audit Info",
      accessor: "express_bl_audit",
      render: (data) => {
        if (
          data.express_bl_generated_by &&
          data.express_bl_generated_by_id &&
          data.express_bl_generated_at
        ) {
          const [datePart, timePart] = data.express_bl_generated_at.split("T");
          const [y, m, d] = datePart.split("-");
          const [h, min] = timePart.split(":");
 
          const hourNum = parseInt(h, 10);
          const hr = hourNum % 12 || 12;
          const ampm = hourNum >= 12 ? "PM" : "AM";
 
          const fullText = `${data.express_bl_generated_by} - ${d}/${m}/${y} ${hr}:${min} ${ampm}`;
 
          return (
            <Tooltip title={fullText} arrow placement="top">
              <div className="ellipsis-cell"
                // style={{
                //   cursor: "pointer",
                //   fontSize: "12px",
                //   maxWidth: "100%"
                 
                // }}
              >
                {fullText}
              </div>
            </Tooltip>
          );
        }
 
        return "-";
      },
    },
 
    {
      label: "Action",
      render: (bookings) => (
        <div className="d-flex gap-2 justify-content-center">
          {bookings.Status_client === "Shipping Instruction Created" && (
            <Link to={`/view-si/admin/${bookings.enq_id}`} title="View SI">
              <VisibilityIcon style={{ fontSize: 20 }} />
            </Link>
          )}
          {(bookings.Status === "BL Draft Created" ||
            bookings.Status === "BL Accepted") && (
            <Link
              to={`/view-bl-draft/${bookings.enq_id}`}
              title="View BL Draft"
            >
              <VisibilityIcon style={{ fontSize: 20 }} />
            </Link>
          )}
          {(bookings.Status_client === "Shipping Instruction Created" ||
            bookings.Status_client === "BL Pending") && (
            <Link to={`/create-si/admin/${bookings.enq_id}`} title="Edit">
              <EditIcon style={{ fontSize: 20 }} />
            </Link>
          )}
          {(bookings.Status === "BL Draft Created" ||
            bookings.Status === "BL Accepted") && (
            <>
              {bookings.switch_bl === "Yes" ? (
                <>
                  <span
                    onClick={() =>
                      handleDownload(
                        bookings.enq_id,
                        "BL Draft BL1",
                        `BL_Draft_BL1_${bookings.enq_id}.pdf`,
                      )
                    }
                    title="Download BL1"
                    style={{ cursor: "pointer" }}
                  >
                    <DownloadIcon style={{ fontSize: 20 }} />
                  </span>
                  <span
                    onClick={() =>
                      handleDownload(
                        bookings.enq_id,
                        "BL Draft BL2",
                        `BL_Draft_BL2_${bookings.enq_id}.pdf`,
                      )
                    }
                    title="Download BL2"
                    style={{ cursor: "pointer" }}
                  >
                    <DownloadIcon style={{ fontSize: 20 }} />
                  </span>
                </>
              ) : (
                <span
                  onClick={() =>
                    handleDownload(
                      bookings.enq_id,
                      "BL Draft",
                      `BL_Draft_${bookings.enq_id}.pdf`,
                    )
                  }
                  title="Download BL"
                  style={{ cursor: "pointer" }}
                >
                  <DownloadIcon style={{ fontSize: 20 }} />
                </span>
              )}
            </>
          )}
        </div>
      ),
    },
  ];
  return (
    <>
      <BackButton />
      {loading ? (
        <p>Loading BL Draft...</p>
      ) : (
        <>
          <Table
            columns={columns}
            data={currentItems}
            loading={loading}
            emptyMessage="No enquiries found."
            itemsPerPage={itemsPerPage}
            pagination={
              <Pagination
                currentPage={currentPage}
                totalPages={totalPages}
                onPageChange={goToPage}
                itemsPerPage={itemsPerPage}
                onItemsPerPageChange={handleItemsPerPageChange}
                totalItems={totalItems}
              />
            }
          />
        </>
      )}
    </>
  );
};
export default ListofBLAdmin;